import { render } from "./PageSection.vue?vue&type=template&id=6a591988"
import script from "./PageSection.vue?vue&type=script&lang=js"
export * from "./PageSection.vue?vue&type=script&lang=js"

import "./PageSection.vue?vue&type=style&index=0&id=6a591988&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__